import React, { Component } from "react";
import {
  showModal,
  getEvolutionPlans,
  getEvolutionPlanTrainingPreRequisites,
} from "actions";
import containsLongRunningProcess from "components/hoc/containsLongRunningProcess";
import { connect } from "react-redux";
import requireAuth from "components/hoc/requireAuth";
import EvolutionPlanPlans from "components/evolutionPlan/EvolutionPlanPlans";
import { Trans } from "react-i18next";

class EvolutionPlanDetail extends Component {
  state = {
    showingEvolutionPlanPlans: {},
  };

  componentDidMount() {
    this.fetchEvolutionPlans();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.employeeId !== this.props.employeeId) {
      this.fetchEvolutionPlans();
    }

    if (
      !prevProps.evolutionPlan.evolutionPlans &&
      this.props.evolutionPlan.evolutionPlans
    ) {
      let showingEvolutionPlanPlans = {};
      this.props.evolutionPlan.evolutionPlans.forEach((pe) => {
        showingEvolutionPlanPlans[pe.level.id] = false;
      });
      this.setState({
        showingEvolutionPlanPlans,
      });
    }
  }

  fetchEvolutionPlans = () => {
    this.props.getEvolutionPlans(
      this.props.employeeId,
      this.onBegin,
      this.onSuccess,
      this.onError
    );
  };

  onBegin = () => {
    this.props.onProcessBegin();
  };
  onSuccess = () => {
    this.props.onProcessEnd();
  };
  onError = (err) => {
    this.props.onProcessEnd();
  };

  toggleEvolutionPlanPlans = (idx) => {
    let showingEvolutionPlanPlans = { ...this.state.showingEvolutionPlanPlans };

    showingEvolutionPlanPlans[idx] = !showingEvolutionPlanPlans[idx];
    this.props.evolutionPlan.evolutionPlans.forEach((pe) => {
      if (pe.level.id !== idx) showingEvolutionPlanPlans[pe.level.id] = false;
    });

    this.setState({ showingEvolutionPlanPlans });
  };

  renderEvolutionPlans = () => {
    if (!this.props.evolutionPlan.evolutionPlans)
      return (
        <tr key="1">
          <td colSpan="6">{this.props.spinner}</td>
        </tr>
      );

    const arr = this.props.evolutionPlan.evolutionPlans.map((ep) => {
      const current = this.state.showingEvolutionPlanPlans[ep.level.id];
      return (
        <React.Fragment key={ep.level.id}>
          <tr
            key={ep.level.id}
            className={`grupEgitim hasChild ${current ? "parent" : null}`}
            onClick={() => this.toggleEvolutionPlanPlans(ep.level.id)}
          >
            <td className="showGrup">{ep.level?.name}</td>
            <td className="showGrup">{ep.totalTrainingCount}</td>
            <td className="showGrup">{ep.toBeCompletedTrainingCount}</td>
            <td className="showGrup">
              <div id="durumChart_1" data-percent="50">
                {ep.levelRatio.toFixed()}
              </div>
            </td>
            <td className="showGrup openCloseBtn">
              {current ? (
                <span className="iconmford fo-icon-remove"></span>
              ) : (
                <span className="iconmford fo-icon-add"></span>
              )}
            </td>
            <td className="childArea" style={{ display: "none" }}></td>
          </tr>
          {current ? (
            <tr className="child">
              <td className="child" colSpan="8">
                <table className="table">
                  <tbody>
                    <EvolutionPlanPlans
                      key={ep.level.id}
                      id={ep.level.id}
                      employeeId={this.props.employeeId}
                      showCompleted={this.props.showCompleted}
                    />
                  </tbody>
                </table>
              </td>
            </tr>
          ) : null}
        </React.Fragment>
      );
    });

    return arr;
  };

  render() {
    if (!this.props.employeeId) return null;

    return (
      <div className="row pb-3">
        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 px-0">
          <table className="table display responsive gPTable" id="gelisimPlani">
            <thead>
              <tr>
                <th className="all">
                  <div className="tableTitle"><Trans desc="Eğitim Grubu">10149</Trans></div>
                </th>
                <th className="desktop">
                  <div className="tableTitle">
                    <Trans desc="Toplam Eğitim Adedi">10150</Trans>
                  </div>
                </th>
                <th className="desktop">
                  <div className="tableTitle">
                    <Trans desc="Tamamlanması Gereken Eğitim Adedi">
                      10151
                    </Trans>
                  </div>
                </th>
                <th className="desktop">
                  <div className="tableTitle">
                    <Trans desc="Grup Tamamlanma Oranı">10152</Trans>
                  </div>
                </th>
                <th className="all">
                  <div className="tableTitle"></div>
                </th>
                <th className="none"></th>
              </tr>
            </thead>
            <tbody>{this.renderEvolutionPlans()}</tbody>
          </table>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    modal: state.modal,
    application: state.application,
    evolutionPlan: state.evolutionPlan.data,
    guide: state.guide,
    profile: state.profile,
  };
};

export default connect(mapStateToProps, {
  showModal,
  getEvolutionPlans,
  getEvolutionPlanTrainingPreRequisites,
})(requireAuth(containsLongRunningProcess(EvolutionPlanDetail)));
